import axios, { AxiosError, AxiosResponse } from 'axios'

import {
  RebillyCreateCustomer,
  RebillyCreateInvoice,
  RebillyCreateOrder,
  RebillyCreatePaymentToken,
  RebillyCreateTransaction,
  RebillyCustomer,
  RebillyInvoice,
  RebillyOrder,
  RebillyPaymentToken,
  RebillyTransaction,
} from './models'

export class RebillyWrapper {
  private publishedKey?: string
  private secretKey?: string
  private organizationId: string
  private static sandboxDomain = 'https://api-sandbox.rebilly.com'
  private static apiDomain = 'https://api.rebilly.com'
  private sandbox: boolean
  constructor(organizationId: string, publishedKey?: string, secretKey?: string, sandbox?: boolean) {
    this.secretKey = secretKey
    this.publishedKey = publishedKey
    this.organizationId = organizationId
    this.sandbox = !!sandbox
  }

  public get apiDomain() {
    return this.sandbox ? RebillyWrapper.sandboxDomain : RebillyWrapper.apiDomain
  }

  public get headers(): Record<string, string> {
    return {
      Authorization: this.secretKey ?? this.publishedKey ?? '',
      'Organization-Id': this.organizationId,
      'REB-APIKEY': this.secretKey ?? this.publishedKey ?? '',
    }
  }

  async createPaymentToken(params: RebillyCreatePaymentToken): Promise<RebillyPaymentToken> {
    return (
      await axios.post<RebillyCreatePaymentToken, AxiosResponse<RebillyPaymentToken>>(`${this.apiDomain}/tokens`, params, {
        headers: this.headers,
      })
    ).data
  }

  async createOrder(params: RebillyCreateOrder): Promise<RebillyOrder> {
    try {
      return (
        await axios.post<RebillyCreateOrder, AxiosResponse<RebillyOrder>>(
          `${this.apiDomain}/subscriptions?expand=recentInvoice,initialInvoice`,
          params,
          {
            headers: this.headers,
          },
        )
      ).data
    } catch (ex) {
      const error = ex as AxiosError
      console.log(`ERROR: ${JSON.stringify(error?.response?.data)}`)
      throw ex
    }
  }

  async createInvoice(params: RebillyCreateInvoice): Promise<RebillyInvoice> {
    return (
      await axios.post<RebillyCreateInvoice, AxiosResponse<RebillyInvoice>>(`${this.apiDomain}/invoices`, params, {
        headers: this.headers,
      })
    ).data
  }

  async createTransaction(params: RebillyCreateTransaction): Promise<RebillyTransaction> {
    return (
      await axios.post<RebillyCreateTransaction, AxiosResponse<RebillyTransaction>>(`${this.apiDomain}/transactions`, params, {
        headers: this.headers,
      })
    ).data
  }

  async createCustomer(params: RebillyCreateCustomer): Promise<RebillyCustomer> {
    return (
      await axios.post<RebillyCreateCustomer, AxiosResponse<RebillyCustomer>>(`${this.apiDomain}/customers`, params, {
        headers: this.headers,
      })
    ).data
  }
}
